// Initial State
const initialState = {
  notes: [],
  error: null
};

// Action constants
const GET_NOTES = 'GET_NOTES';
const GET_NOTES_SUCCESS = 'GET_NOTES_SUCCESS';
const GET_NOTES_FAILURE = 'GET_NOTES_FAILURE';

const ADD_PHARMACY_NOTE = 'ADD_PHARMACY_NOTE';
const ADD_PHARMACY_NOTE_SUCCESS = 'ADD_PHARMACY_NOTE_SUCCESS';
const ADD_PHARMACY_NOTE_FAILURE = 'ADD_PHARMACY_NOTE_FAILURE';

// Action creators
export const getPharmacyNotes = pharmacyId => {
  return {
    types: [GET_NOTES, GET_NOTES_SUCCESS, GET_NOTES_FAILURE],
    payload: {
      request: {
        url: `/notes/${pharmacyId}`,
        method: 'GET',
      }
    }
  };
};

export const addPharmacyNote = (pharmacyId, text) => ({
  types: [ADD_PHARMACY_NOTE, ADD_PHARMACY_NOTE_SUCCESS, ADD_PHARMACY_NOTE_FAILURE],
  payload: {
    request: {
      url: 'notes',
      method: 'POST',
      data: { text, pharmacy_id: pharmacyId }
    }
  }
});

const notesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTES_SUCCESS:
      return {
        ...state,
        notes: action.payload.data.data
      };

    case ADD_PHARMACY_NOTE:
      return {
        ...state,
        error: null
      }

    case ADD_PHARMACY_NOTE_FAILURE:
      return {
        ...state,
        error: action.payload.data.error
      };

    case ADD_PHARMACY_NOTE_SUCCESS:
      return {
        ...state,
        notes: [action.payload.data.data[0], ...state.notes],
      };

    default:
      return state;
  }
};

export default notesReducer;
